var indentation_default = {
  "indentZero": "k84Lu",
  "indentOne": "VVvbD",
  "indentTwo": "WTnLE",
  "indentThree": "IXLDV",
  "indentFour": "rVbz7",
  "indentFive": "nS4m8",
  "indentSix": "YkUwC"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
